import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { makeStyles, lighten } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

import "./FilterButton.scss";

const useStyles = makeStyles((theme) => ({
  selectedFilterBackground: {
    backgroundColor: lighten(theme.palette.primary.main, 0.92),
    borderColor: theme.palette.primary.main,
  },
}));

export default function FilterButton({label, icon, inputs, setDefaultFilter}) {
  const classes = useStyles();

  const [isSelected, setIsSelected] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState();
  const [selectedIcon, setSelectedIcon] = useState();
  const filterDefault = inputs.props.fields[0].default;

  useEffect(() => {
    if (inputs) {
      const selected = inputs.props.fields[0].radio.some(r => r.selected === true);
      const current = inputs.props.fields[0].radio.find(r => r.selected);
      
      setIsSelected(selected);
      if (current !== undefined) {
        setSelectedLabel(current.label);
        setSelectedIcon(current.icon);
      };
    };
  }, [inputs]);
  return (
    <button className={`filter-select ${isSelected ? classes.selectedFilterBackground + " filtering" : ""}`}>
        {isSelected ? selectedIcon : icon}<span>{isSelected ? selectedLabel : label }</span>
        {isSelected && <span className="filter-reset" onClick={() => {setDefaultFilter(filterDefault)}}><CloseIcon style={{ fontSize: 14 }} /></span>}
        <div className="input-container">
          {inputs}
        </div>
    </button>
  )
};

FilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  inputs: PropTypes.element.isRequired,
  setDefaultFilter: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/Common/FilterButton.js